import React, {useEffect} from 'react';
import GridContainer from '../../../@crema/core/GridContainer';
import Grid from '@material-ui/core/Grid/Grid';
import AppCard from '../../../@crema/core/AppCard';
import Box from '@material-ui/core/Box/Box';
import {Fonts} from '../../../shared/constants/AppEnums';
import {BuyBackForm} from './BuyBackForm';
import {fetchBuyback} from '../../../redux/actions';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../../redux/store';
export const BuyBackPrice: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();
  const buyback = useSelector<AppState, AppState['buyback']>(
    ({buyback}) => buyback,
  );

  useEffect(() => {
    dispatch(fetchBuyback());
  }, []);

  return (
    <Box pt={{md: 4}}>
      <Box
        component='h2'
        color='text.primary'
        mb={{xs: 4, sm: 4, xl: 6}}
        mt={{xs: 4, sm: 0}}
        fontSize={{xs: 18, sm: 20, xl: 22}}
        textAlign={{xs: 'center', sm: 'left'}}
        fontFamily={Fonts.LIGHT}
      >
        Buyback management
      </Box>

      <GridContainer>
        <Grid item xs={12} sm={5}>
          <AppCard title='Enabled' height={1}>
            <Box
              textAlign={{xs: 'center', sm: 'left'}}
              component='p'
              color='grey.400'
              mb={{xs: 1, md: 3, lg: 5}}
            >
              Allow users to buy Aument token from website
            </Box>

            <Box
              component='span'
              display='block'
              color='primary.main'
              fontFamily={Fonts.EXTRA_BOLD}
              textAlign={{xs: 'center', sm: 'left'}}
              fontSize={{xs: 24, xl: 30}}
            >
              {buyback.data && buyback.data.buyback
                ? `${buyback.data.sellPrice} USD`
                : 'Currently disabled'}
            </Box>
          </AppCard>
        </Grid>

        <Grid item xs={12} sm={7}>
          <AppCard title='Update buyback option' height={1}>
            <BuyBackForm
              disabledForm={buyback.isSaving}
              initialPrice={buyback.data ? buyback.data.sellPrice : 0}
              enabled={buyback.data ? buyback.data.buyback : false}
            />
          </AppCard>
        </Grid>
      </GridContainer>
    </Box>
  );
};
